<template>
    <div id="Section-05" class="section-05 wsl-flex-center-ng">
        <div class="container">
            <div class="wsl-show-sm wsl-show-xs"
                 :style="{backgroundImage: `url(${s05Bg1}`}"
                 style="
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;">

                <div class="cb-bg-blue block-header wsl-p-y-10">
                    <div class="wsl-flex-middle-ng">
                        <div class="Oswald-Regular wsl-bg-white cb-cyan t24 wsl-flex-center-middle-ng wsl-p-x-6">05</div>
                        <div class="Oswald-Regular cb-cyan t24 wsl-m-l-15">Билеты</div>
                    </div>
                </div>

                <div class="wsl-show-sm wsl-show-xs wsl-p-a-15" style="
                    background-color: #fff;">
                    <div class="wsl-flex-middle-ng">
                        <div class="wsl-text-left wsl-p-x-30" style="line-height: 1.2;">
                            <div>
                                <span class="Oswald-Light cb-cyan t36">Авиа касса</span>
                                <span class="Oswald-Light cb-blue t36"> за 15 минут </span>
                                <span class="Oswald-Light cb-blue t36">без затрат</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="wsl-p-y-60 padding-sm-xs">
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Более <span class="cb-blue">300</span> авиакомпаний по ценам GDS систем в режиме <span
                            class="cb-blue">24/7</span>
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Выписка субсидированных, чартерных, групповых билетов и сложных маршрутов
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Сбор за выписку билета для заказчика устанавливаете вы
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Простая схема пост оплаты за выписанный билет с оплатой в течении суток<br>
                        <span class="cb-blue">БРОНИРУЙ-ВЫПИСЫВАЙ-ПЛАТИ ПОЗЖЕ</span>
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Бронь авиабилета сохраняется на срок , отмена без штрафов и сборов
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Отсутствие плана продаж и депозитов
                    </div>
                    <div class="wsl-m-t-60 wsl-m-b-10 wsl-text-center">
                        <a class="cb-btn-blue wsl-inline-block z-depth-3" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                    </div>
                </div>
            </div>

            <div class="wsl-relative wsl-show-md"
                 :style="{backgroundImage: `url(${s05Bg1}`}"
                 style="
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;">

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s05Bg2}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    bottom: 0; right: 0; width: 33.34%; height: 100%;">
                    <div class="wsl-w-100 wsl-h-100 wsl-relative">
                        <div class="wsl-abs wsl-abs-top wsl-flex-middle-ng" style="top: 5%; left: 10%;">
                            <div class="Oswald-Regular wsl-bg-white cb-cyan t30 wsl-flex-center-middle-ng wsl-p-x-6">05
                            </div>
                            <div class="Oswald-Regular cb-cyan t30 wsl-m-l-15">Билеты</div>
                        </div>
                    </div>
                </div>

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s07Bg3}`}"
                     style="
                    background-color: #fff;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: left top;
                    top: 20.63%; right: 6.23%; width: 31.36%; height: 61.76%;">
                    <div class="wsl-flex-middle-ng wsl-h-100">
                        <div class="wsl-text-left wsl-p-r-10" style="line-height: 1.2; padding-left: 48px;">
                            <div>
                                <span class="Oswald-Light cb-cyan t36">Авиа касса</span><br>
                                <span class="Oswald-Light cb-blue t36">за 15 минут</span><br>
                                <span class="Oswald-Light cb-blue t36">без затрат</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="wsl-p-y-60" style="padding-left: 5%; padding-right: 40%;">
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Более <span class="cb-blue">300</span> авиакомпаний по ценам GDS систем в режиме <span
                            class="cb-blue">24/7</span>
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Выписка субсидированных, чартерных, групповых билетов и сложных маршрутов
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Сбор за выписку билета для заказчика устанавливаете вы
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Простая схема пост оплаты за выписанный билет с оплатой в течении суток<br>
                        <span class="cb-blue">БРОНИРУЙ-ВЫПИСЫВАЙ-ПЛАТИ ПОЗЖЕ</span>
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Бронь авиабилета сохраняется на срок , отмена без штрафов и сборов
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Отсутствие плана продаж и депозитов
                    </div>
                    <div class="wsl-m-t-60 wsl-m-b-10 wsl-text-center">
                        <a class="cb-btn-blue wsl-inline-block z-depth-3" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                    </div>
                </div>

            </div>

            <div class="wsl-w-100 wsl-h-100 wsl-relative wsl-hide-md wsl-hide-sm wsl-hide-xs">
                <img alt="" class="wsl-w-100 wsl-h-100"
                     src="../assets/img/s05-bg1.jpg">

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s05Bg2}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    bottom: 0; right: 0; width: 33.34%; height: 100%;">
                    <div class="wsl-w-100 wsl-h-100 wsl-relative">
                        <div class="wsl-abs wsl-abs-top wsl-flex-middle-ng" style="top: 5%; left: 10%;">
                            <div class="Oswald-Regular wsl-bg-white cb-cyan t30 wsl-flex-center-middle-ng wsl-p-x-6">05
                            </div>
                            <div class="Oswald-Regular cb-cyan t30 wsl-m-l-15">Билеты</div>
                        </div>
                    </div>
                </div>

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s07Bg3}`}"
                     style="
                    background-color: #fff;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: left top;
                    top: 20.63%; right: 6.23%; width: 31.36%; height: 61.76%;">
                    <div class="wsl-flex-middle-ng wsl-h-100">
                        <div class="wsl-text-left wsl-p-r-10" style="line-height: 1.2; padding-left: 48px;">
                            <div>
                                <span class="Oswald-Light cb-cyan t48">Авиа касса</span><br>
                                <span class="Oswald-Light cb-blue t48">за 15 минут</span><br>
                                <span class="Oswald-Light cb-blue t48">без затрат</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="wsl-abs" style="top: 10%; padding-left: 6%; padding-right: 35%;">
                    <div class="Oswald-Light t24 wsl-m-y-40 cb-white">
                        Более <span class="cb-blue">300</span> авиакомпаний по ценам GDS систем в режиме <span
                            class="cb-blue">24/7</span>
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-40 cb-white">
                        Выписка субсидированных, чартерных, групповых билетов и сложных маршрутов
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-40 cb-white">
                        Сбор за выписку билета для заказчика устанавливаете вы
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-40 cb-white">
                        Простая схема пост оплаты за выписанный билет с оплатой в течении суток<br>
                        <span class="cb-blue">БРОНИРУЙ-ВЫПИСЫВАЙ-ПЛАТИ ПОЗЖЕ</span>
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-40 cb-white">
                        Бронь авиабилета сохраняется на срок , отмена без штрафов и сборов
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-40 cb-white">
                        Отсутствие плана продаж и депозитов
                    </div>
                    <div class="wsl-m-t-80 wsl-m-b-30 wsl-text-center">
                        <a class="cb-btn-blue wsl-inline-block z-depth-3" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Section-05',
  props: {
    s05Bg1: String,
    s05Bg2: String,
    s07Bg3: String
  }
}
</script>

<style scoped>

</style>
